export default {
  display: false,
  y: 'bottom',
  x: null,
  mode: '',
  timeout: 3000,
  text: '',
  color: 'undefined',
  buttonColor: '#fff',
  buttonText: 'CERRAR',
  showButton: true,
  flat: true
}



// WEBPACK FOOTER //
// ./src/config/snackbar.js